import { RestAPIEndpoints } from '@lifeomic/react-client';
import { useCallback } from 'react';
import { apiHooks } from '../../../hooks/useRestAPIHooks';
import { ModelUtils } from '../models';

type TemplatingItemDetailResponse =
  RestAPIEndpoints['GET /v1/ai-templates/durable/:durableId']['Response'];

export type UseTemplatingItemDetailQueryArgs = {
  durableId?: string;
};

export const useTemplatingItemDetailQuery = ({
  durableId,
}: UseTemplatingItemDetailQueryArgs) => {
  const select = useCallback(({ template }: TemplatingItemDetailResponse) => {
    if (!template) return undefined;
    return ModelUtils.templatingItemDetailFromRawData(template);
  }, []);

  const templatingItemDetailQuery = apiHooks.useAPIQuery(
    'GET /v1/ai-templates/durable/:durableId',
    { durableId: durableId ?? '' },
    { select, enabled: !!durableId },
  );

  return templatingItemDetailQuery;
};
